import { Badge } from '@/components';

import {
  INTEGRATION_REQUEST_STATUS_COLORS,
  INTEGRATION_REQUEST_STATUS_LABELS,
  type IntegrationRequestStatus,
} from '../../../../models/IntegrationRequest';

const IntegrationRequestStatusBadge = ({
  status,
}: {
  status: IntegrationRequestStatus;
}) => (
  <Badge
    value={INTEGRATION_REQUEST_STATUS_LABELS[status] ?? status}
    {...INTEGRATION_REQUEST_STATUS_COLORS[status]}
  />
);

export default IntegrationRequestStatusBadge;
